import { Injectable } from '@angular/core';

import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject } from 'rxjs';

import { AuthStore } from './auth.store';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private jwtHelper: JwtHelperService;
  private userAuthenticated: BehaviorSubject<boolean> = new BehaviorSubject(false);

  constructor(
    private authStore: AuthStore
  ) {
    this.jwtHelper = new JwtHelperService();
  }

  login(token: string) {
    this.authStore.setToken(token);
    this.updateState();
  }

  logout() {
    this.authStore.clearToken();
    this.updateState();
  }

  isLoggedIn(): boolean {
    this.updateState();
    return this.userAuthenticated.getValue();
  }

  updateState() {
    this.userAuthenticated.next(this.isTokenValid());
  }

  isTokenValid(): boolean {
    const token = this.getAsyncToken();
    return !this.jwtHelper.isTokenExpired(token);
  }

  getAsyncToken() {
    return this.authStore.getToken();
  }

  getUserName() {
    if(this.getAsyncToken()){
      const decodedToken = this.jwtHelper.decodeToken(this.getAsyncToken());
      return decodedToken['jti'];
    }
  }
}
